/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseQueryItemType from './BaseQueryItemType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseQueryItemType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}baseQueryItemType"&gt; &lt;sequence&gt; &lt;element name="numberOfDistinctValues" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="refToHierarchy" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class NamedSet extends BaseQueryItemType{

	numberOfDistinctValues = null;

	refToHierarchy = null;



	/**
	 * Gets the value of the numberOfDistinctValues property.
	 * @return {String} possible object is {@link String}
	 */
	getNumberOfDistinctValues() {
		return this.numberOfDistinctValues;
	}

	/**
	 * Sets the value of the numberOfDistinctValues property.
	 * @param {String} value allowed object is {@link String}
	 */
	setNumberOfDistinctValues(value) {
		var oldValue = this.numberOfDistinctValues;
		this.numberOfDistinctValues = value;
		this._setAndNotify(69, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the refToHierarchy property.
	 * @return {String} possible object is {@link String}
	 */
	getRefToHierarchy() {
		return this.refToHierarchy;
	}

	/**
	 * Sets the value of the refToHierarchy property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRefToHierarchy(value) {
		var oldValue = this.refToHierarchy;
		this.refToHierarchy = value;
		this._setAndNotify(70, oldValue, value, false, true);
	}

	/**
	 * Creates a new instance of <code>NamedSet</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> NamedSet</code> object from.
	 * @return {NamedSet} an object of type <code>NamedSet</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createNamedSet();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "NamedSet";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 69, "numberOfDistinctValues", null));
		featureList.push(this.createFeature(false, false, false, 70, "refToHierarchy", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 69:
			this.setNumberOfDistinctValues((value));
			break;
		case 70:
			this.setRefToHierarchy((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 69:
			return this.getNumberOfDistinctValues();
		case 70:
			return this.getRefToHierarchy();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 69:
			return this.getNumberOfDistinctValues();
		case 70:
			return this.getRefToHierarchy();
		default:
			return super.basicGet(featureID);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/NamedSet.js